import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BOMRepository from "../../../repository/BOMRepository";
import { __remove, __set } from "../../axios_indicator";

export const fetchBOMList = createAsyncThunk('bom_fetchBOMList', async (prams) => {
  __set('BOM_API_CALL');
  return await new BOMRepository().fetchBOMList(prams);
});

export const getBomDetailByBomID = createAsyncThunk('bom_getBomDetailByBomID', async (params) => {
  __set('BOM_API_CALL');
  return await new BOMRepository().getBomDetailByBomID(params.bomId)
});

export const getBomHealthByBomID = createAsyncThunk('bom_getBomHealthByBomID', async (params) => {
  __set('BOM_HEALTH_API_CALL');
  return await new BOMRepository().getBomHealthByBomID(params.bomId)
});

export const getBomDetailByBomIDWithType = createAsyncThunk('bom_getBomDetailByBomIDWithType', async (params) => {
  __set('BOM_TAB_API_CALL');
  if (params.top === undefined) {
    params.top = 10;
  }
  if (params.force_all_skip_redux_check === undefined) {
    params.force_all_skip_redux_check = false;
  }

  return await new BOMRepository().getBomDetailByBomIDWithType(params.bomId, params.matchType, params.sortColumn, params.sortOrder, params.isReRunPartMatch, params.top, params.force_all_skip_redux_check, params.callFrom, params.skip)
});

export const getBomDetailCountByBomID = createAsyncThunk('bom_getBomDetailCountByBomID', async (params) => {
  __set('BOM_TAB_API_CALL');
  if (params.top === undefined) {
    params.top = 10;
  }
  if (params.force_all_skip_redux_check === undefined) {
    params.force_all_skip_redux_check = false;
  }
  return await new BOMRepository().getBomDetailCountByBomID(params.bomId)
});

export const download_bom_template = createAsyncThunk('bom_download_bom_template', async () => {
  return await new BOMRepository().downloadBomTemplate()
});

export const updateCustomerPartNumberByBomDetailID = createAsyncThunk('bom_detail_updateCustomerPartNumberByBomDetailID', async (params) => {
  return await new BOMRepository().updateCustomerPartNumberByBomDetailID(params)
});

export const fetch_static_columns = createAsyncThunk('bom_fetchStaticColumns', async () => {
  __set('BOM_REMATCH_API_CALL');
  return await new BOMRepository().fetchStaticColumns();
});

export const fetch_saved_columns_data_by_bom_id = createAsyncThunk('bom_fetchSavedColumnsDataByBomID', async (params) => {
  __set('BOM_REMATCH_SAVED_API_CALL');
  return await new BOMRepository().fetchSavedColumnsDataByBomID(params);
});

export const getNewarkBomList = createAsyncThunk('bom_fetch_Newark_bom_list', async (params) => {
  __set('BOM_NEWARK_LIST_API_CALL');
  return await new BOMRepository().getNewarkBomList(params)
});

const initialState = {
  bomList: {},
  bomDetailByBomID: {},
  bomDetailByBomIDWithType: {},
  bomUploadFile__progress_percentage: 0,
  bomHealthByBomID: {},
  bomMultipleMatchTrigger: '',
  bomSortByUpdatedDate: false,
  row_selected_number: 1,
  static_columns: {},
  bomDataList: {},
  bomDataListMainCopy: {},
  columnMappingList: {},
  total_bom: 0,
  bomProjectList: {},
  yourBomListing: {},
  yourBomListingWithProject: {},
  downloadLoader: false,
  newarkBomList: {}
};


export const fetch_project_list = createAsyncThunk('bom_project_list', async () => {
  __set('BOM_API_CALL');
  let direct_res = await new BOMRepository().listProject()
  let bomProjectList = {};
  let res = {};
  if (direct_res.data && Array.isArray(direct_res.data) && direct_res.data.length > 0) {
    direct_res.data.map((v) => {
      bomProjectList[v.projectId] = v;
    });
  }
  res.bomProjectList = bomProjectList;
  return res;
});

export const fetch_bom_project_detail_with_bom = createAsyncThunk('bom_project_detail_with_bom', async (params) => {
  __set('BOM_PROJECT_API_CALL');
  return await new BOMRepository().listProjectDetailWithBOM(params);
});
const slice = createSlice({
  name: "BOM",
  initialState: initialState,
  reducers: {
    SET_bomUploadFile__progress_percentage: {
      reducer: (state, action) => {
        state.bomUploadFile__progress_percentage = action.payload.percentage
      },
    },
    SET_quantity_exact_match_tab_by_bomDetailId: {
      reducer: (state, action) => {
        const { bomDetailId, quantity, customerPartNumber } = action.payload;
        if (quantity) {
          state.bomDetailByBomIDWithType.Exact.records[bomDetailId].quantity = quantity;
        } else {
          state.bomDetailByBomIDWithType.Exact.records[bomDetailId].customerPartNumber = customerPartNumber || null;
        }
      }
    },
    FORCE_remove_bomDetailByBomIDWithType_by_type: {
      reducer: (state, action) => {
        state.bomDetailByBomIDWithType[action.payload.matchType].records = {};
        return state;
      },
    },
    SET_bomMultipleMatchTrigger: {
      reducer: (state, action) => {
        state.bomMultipleMatchTrigger = action.payload.BOMTriggerVal
      },
    },
    SET_bomSortByUpdatedDate: {
      reducer: (state, action) => {
        state.bomSortByUpdatedDate = true
      },
    },
    SET_bomDataList_based_on_ROW_selected: {
      reducer: (state, action) => {
        state.row_selected_number = parseInt(action.payload.row_selected_number)
        let b = state.bomDataListMainCopy;
        b = b.filter((v, i) => {
          const row = i + 1;
          return row >= action.payload.row_selected_number;
        });
        state.bomDataList = b
      },
    },
    SET_DOWNLOAD_LOADER: {
      reducer: (state, action) => {
        if (state.yourBomListing && Object.entries(state.yourBomListing).length > 0 && !action.payload.projectId) {
          if (state.yourBomListing[action.payload.bomId]) {
            state.yourBomListing[action.payload.bomId].isDownloadLoad = action.payload.isLoad
          }
        }
        if (state.bomProjectList && Object.entries(state.bomProjectList).length > 0 && action.payload.projectId !== '') {
          if (state.bomProjectList[action.payload.projectId]) {
            if (state.bomProjectList[action.payload.projectId].bom_listing[action.payload.bomId]) {
              state.bomProjectList[action.payload.projectId].bom_listing[action.payload.bomId].isDownloadLoad = action.payload.isLoad
            }
          }
        }
      },
    },

    UPDATE_BomNewarkData: {
      reducer: (state, action) => {
        state.newarkBomList.manufacturerPartNumberSearchReturn.products = state.newarkBomList.manufacturerPartNumberSearchReturn.products.map((product) => {
          if (product.sku === action.payload.params?.sku) {
            return {
              ...product,
              translatedMinimumOrderQuality: action.payload.params.value,
              qtyError: action.payload.params.value < 1 || action.payload.params.value > product.stock.level ? true : false
            };
          }
          return product;
        });
      },
    },

  },
  extraReducers: {
    [fetchBOMList.fulfilled]: (state, { payload }) => {
      state.bomList = payload.bomList;
      __remove('BOM_API_CALL');
      return state;
    },
    [fetchBOMList.rejected]: (state, { payload }) => {
      __remove('BOM_API_CALL');
    },
    [getBomDetailByBomID.fulfilled]: (state, { payload }) => {
      state.bomDetailByBomID = payload;
      __remove('BOM_API_CALL');
      return state;
    },
    [getBomDetailByBomID.rejected]: (state, { payload }) => {
      __remove('BOM_API_CALL');
    },
    [getBomDetailByBomIDWithType.fulfilled]: (state, { payload }) => {
      const res = { ...payload.data }
      if (payload.data?.Exact?.records) {
        // Convert the object of objects into an array of key-value pairs
        const arrayOfKeyValuePairs = Object.entries(payload.data?.Exact?.records);

        // Sort the array based on the 'index' key in inner objects
        arrayOfKeyValuePairs.sort(([, objA], [, objB]) => objA.index - objB.index);

        // Reconstruct the object from the sorted array
        res.Exact.records = arrayOfKeyValuePairs.reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {})
      }

      state.bomDetailByBomIDWithType = res;
      __remove('BOM_TAB_API_CALL');
      return state;
    },
    [getBomDetailByBomIDWithType.rejected]: (state, { payload }) => {
      __remove('BOM_TAB_API_CALL');
    },
    [getBomHealthByBomID.fulfilled]: (state, { payload }) => {
      state.bomHealthByBomID = payload;
      __remove('BOM_HEALTH_API_CALL');
      return state;
    },
    [getBomHealthByBomID.rejected]: (state, { payload }) => {
      __remove('BOM_HEALTH_API_CALL');
    },
    [fetch_static_columns.fulfilled]: (state, { payload }) => {
      __remove('BOM_REMATCH_API_CALL');
      if (Object.entries(payload).length > 0) {
        Object.entries(payload).map((v) => {
          state.static_columns[v[0]] = {
            bomColumnName: v[0],
            fileColumnName: v[1],
          };
        });
      }
      return state;
    },
    [fetch_static_columns.rejected]: (state, { payload }) => {
      __remove('BOM_REMATCH_API_CALL');
    },
    [fetch_saved_columns_data_by_bom_id.fulfilled]: (state, { payload }) => {
      __remove('BOM_REMATCH_SAVED_API_CALL');
      if (payload.bomDataList !== undefined && payload.bomDataList.length > 0) {
        payload.bomDataList.map((v, i) => {
          payload.bomDataList[i].row_counter_number = i + 1;
        })
        state.bomDataList = payload.bomDataList
        state.bomDataListMainCopy = payload.bomDataList
      }
      if (payload.columnMappingList !== undefined && payload.columnMappingList.length > 0) {
        payload.columnMappingList.map((v) => {
          v.fileColumnName = v.fileColumnName.trim();
          v.bomColumnName = v.fileColumnName.trim();
          state.columnMappingList[v.fileColumnName] = v;
        });
      }
      return state;
    },
    [fetch_saved_columns_data_by_bom_id.rejected]: (state, { payload }) => {
      __remove('BOM_REMATCH_SAVED_API_CALL');
    },
    [fetch_project_list.fulfilled]: (state, { payload }) => {
      __remove('BOM_API_CALL');
      state.bomProjectList = payload.bomProjectList;
      return state;
    },
    [fetch_project_list.rejected]: (state, { payload }) => {
      __remove('BOM_API_CALL');
      return state;
    },
    [fetch_bom_project_detail_with_bom.fulfilled]: (state, { payload }) => {
      __remove('BOM_PROJECT_API_CALL');
      state.total_bom = payload.total_bom;
      state.bomProjectList = payload.project_listing;
      state.yourBomListing = payload.your_bom_listing;
      state.yourBomListingWithProject = payload.your_bom_listing_with_project;
      return state;
    },
    [fetch_bom_project_detail_with_bom.rejected]: (state, { payload }) => {
      __remove('BOM_PROJECT_API_CALL');
    },
    [getNewarkBomList.fulfilled]: (state, { payload }) => {
      state.newarkBomList = payload.data;
      __remove('BOM_NEWARK_LIST_API_CALL');
      return state;
    },
    [getNewarkBomList.rejected]: (state, { payload }) => {
      __remove('BOM_NEWARK_LIST_API_CALL');
    },
  },
});

export const {
  SET_bomUploadFile__progress_percentage,
  SET_quantity_exact_match_tab_by_bomDetailId,
  FORCE_remove_bomDetailByBomIDWithType_by_type,
  SET_bomMultipleMatchTrigger,
  SET_bomSortByUpdatedDate,
  SET_bomDataList_based_on_ROW_selected,
  SET_DOWNLOAD_LOADER,
  UPDATE_BomNewarkData
} = slice.actions;

export default slice.reducer;
